import { mapArrayElement } from "../../common";
export function mapParticipantSlims(participantsSlims) {
    return participantsSlims.map(data => ({
        id: data[0],
        name: data[1],
        type: data[2],
        seoIdentifier: data[3],
    }));
}
export function mapDisplayOdds(data) {
    return {
        american: data[0],
        decimal: data[1],
        fractional: data[2],
    };
}
export function mapSportsbookSelectionsUpdate(data) {
    return {
        id: data[0],
        label: data[1],
        displayOdds: mapDisplayOdds(data[2]),
        trueOdds: data[3],
        points: data[4],
        sortOrder: data[5]
    };
}
export function mapMarketOffersSelectionsUpdate(data) {
    return {
        id: data[0],
        betSlipLine: data[1],
        trueOdds: data[2],
        displayOdds: mapDisplayOdds(data[3]),
        points: data[4],
        displayPoints: data[5],
        tags: data[6],
        marketId: data[7],
        replacedSelectionId: data[8],
    };
}
export function mapMarketOffersSelectionsUpdates(data) {
    return {
        id: data[0],
        betSlipLine: data[1],
        isLive: data[2],
        eventId: data[3],
        isSuspended: data[4],
        tags: data[5],
        oppositeMarketId: data[6],
        blurb: data[7],
        blurbId: data[8],
    };
}
export function mapSportsbookSelection(data) {
    return {
        id: data[0],
        marketId: data[1],
        label: data[2],
        displayOdds: mapDisplayOdds(data[3]),
        trueOdds: data[4],
        points: data[5],
        outcomeType: data[6],
        participants: mapArrayElement(data[7], mapParticipantSlims),
        sortOrder: data[8]
    };
}
//# sourceMappingURL=mapSportsbookSelections.js.map